import { useEffect, useMemo } from "react";
import { Helmet } from "react-helmet-async";
import LorsHero from "@/components/landing/lors/LorsHero";
import LorsTestimonials from "@/components/landing/lors/LorsTestimonials";
import LorsAbout from "@/components/landing/lors/LorsAbout";
import LorsRegistration from "@/components/landing/lors/LorsRegistration";
import LorsFooter from "@/components/landing/lors/LorsFooter";
import LorsStickyCta from "@/components/landing/lors/LorsStickyCta";
import { getDec17Copy } from "@/components/landing/lors/translationsDec17";
import { captureUtmsFromUrl } from "@/components/landing/lors/utmStorage";

const REDIRECT_TO = "/december-17-2026/ty";

const Dec172026 = () => {
  useEffect(() => {
    captureUtmsFromUrl();
    const prev = document.documentElement.lang;
    document.documentElement.lang = "en";
    return () => {
      document.documentElement.lang = prev;
    };
  }, []);

  const copy = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return getDec17Copy(params.get("h"));
  }, []);

  const pageTitle = "Estate Planning Essentials for Families — Free Online Webinar";
  const pageDescription =
    "Free live webinar on December 17th at 12:00 PM PT with attorney Ruby Steinbrecher. Learn how California families use trusts to avoid probate court.";
  const pageUrl = "https://events.lawofficeofruby.com/december-17-2026";

  return (
    <main className="lors-theme">
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:type" content="website" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <link rel="canonical" href={pageUrl} />
      </Helmet>
      <LorsHero
        copy={copy}
        redirectTo={REDIRECT_TO}
        headlineSizeClass="text-4xl md:text-[64px] leading-tight md:leading-[80px] font-bold"
        bulletsMontserrat
        formKey="dec17"
      />
      <LorsTestimonials copy={copy} lang="en" />
      <LorsAbout copy={copy} />
      <LorsRegistration copy={copy} />
      <div
        className="py-6 border-t"
        style={{
          backgroundColor: "hsl(0 0% 100%)",
          borderColor: "hsl(199 21% 86%)",
        }}
      >
        <div className="container max-w-[1320px] mx-auto px-6 text-xs leading-relaxed" style={{ color: "hsl(210 24% 35%)" }}>
          <p>
            <strong>Disclaimer:</strong> The information provided on this website is for general
            informational and educational purposes only and does not constitute legal advice. Viewing
            this site, attending the event, or contacting the Law Office of Ruby Steinbrecher does
            not create an attorney-client relationship. An attorney-client relationship is formed only
            through a signed written engagement agreement. For advice regarding your specific
            situation, please consult a licensed attorney.
          </p>
        </div>
      </div>
      <LorsFooter copy={copy} />
      <LorsStickyCta copy={copy} />
    </main>
  );
};

export default Dec172026;
